export const NEW_MESSAGE_FOR_CLEANING_REPORT_ADDED =
  'NEW_MESSAGE_FOR_CLEANING_REPORT_ADDED';

export const NEW_MESSAGE_FOR_NOTIFICATION_ADDED =
  'NEW_MESSAGE_FOR_NOTIFICATION_ADDED';
